<script lang="ts">
	import { currentLanguage } from '$lib/stores/i18n';
	import ServicePage from '../../3dprintingservice/+page.svelte';

	export let data: { lang?: string };

	// Set language from route parameter
	$: if (data?.lang) {
		currentLanguage.set(data.lang as 'en' | 'th');
	}
</script>

<ServicePage />
